import React, {useEffect} from 'react';
import './style.css';
import {useSelector} from "react-redux";
import {ApplicationState} from "../../../store";
import {SettingsState} from "../../../store/settings/types";
import MyDate from "../../../utils/MyDate";

interface Props {
    time: number,
    pane: number
}

const PaneTimeComponent: React.FC<Props> = ({time, pane}) => {
    const { isLocalTime } = useSelector<ApplicationState, SettingsState>(state => state.settings);

    return (
        <span  className={'pane-time'}
               id={'pane-time-' + pane}
        > 
        { isLocalTime
            ? new MyDate(time).toLocaleString()
            : new MyDate(time).to24String()
        } </span>
    );
};

export default PaneTimeComponent;